<template>
  <div>
    <app-bar
      ref="refAppBar"
      :cast_id="cast_id"
      @on_back="onBack"
      @on_history="onHistory"
    ></app-bar>
    <v-divider></v-divider>
    <v-card tiletile elevation="0" class="item-card pa-2">
      <v-card-text class="pa-0">
        <div>
          <cast-profile-component
            :cast_data="castData"
          ></cast-profile-component>
        </div>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <generate-comment-component
      :type="type"
      :cast_id="cast_id"
      :mode="'page'"
      :cast_name="null"
      :cast_props="null"
    ></generate-comment-component>
    <history-drawer-component
      :type="type"
      :drawer="drawer"
      :cast_id="cast_id"
      @update:drawer="drawer = $event"
    ></history-drawer-component>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
  computed,
  onMounted,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import { useRouter } from "@/utils";
import appBar from "./appBar.vue";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import retryRequest from "@/common/retryRequest";
import castProfileComponent from "./component/castProfile.vue";
import shopCommentComponent from "./component/shopComment.vue";
import castCommentComponent from "./component/shopComment.vue";
import historyDrawerComponent from "./component/historyDrawer.vue";
import generateCommentComponent from "./component/generateComment.vue";

export default defineComponent({
  components: {
    appBar,
    castProfileComponent,
    historyDrawerComponent,
    generateCommentComponent,
  },
  props: ["type", "cast_id"],
  setup(props, ctx) {
    const { router } = useRouter();
    const refAppBar = ref();
    const CastsRepository = repositoryFactory.get("casts");

    const state = reactive({
      castData: {},
      drawer: false,
    });

    // ブラウザバック
    const onBack = async () => {
      router.back();
    };

    // 履歴表示(ドロワーを開閉)
    const onHistory = async () => {
      state.drawer = !state.drawer;
    };

    // 初期処理
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const currentShop = store.getters["shops/currentShop"];

      // castIDチェック
      state.castData = {};
      const params = new URLSearchParams();
      params.append("shop_id", currentShop.id);
      params.append("cast_id", props.cast_id);
      await CastsRepository.get_shopid(params)
        .then((response) => {
          if (response.data) {
            // 取得データをセット
            // state.castData = response.data;
            state.castData = {};
            set(state.castData, "id", response.data.id);
            set(state.castData, "name", response.data.name);
            set(state.castData, "image", response.data.image);
            set(state.castData, "shop_id", currentShop.id);
            for (let idx in response.data.prop) {
              response.data.prop[idx].key.startsWith(`cast__basic__`) &&
                set(
                  state.castData,
                  response.data.prop[idx].key.replace("cast__basic__", ""),
                  response.data.prop[idx].value
                );
            }

            // for (let idx in response.data.prop) {
            //   response.data.prop[idx].key.startsWith(`cast__genai__`) &&
            //     set(
            //       state.castGenaiData,
            //       response.data.prop[idx].key.replace(`cast__genai__`, ""),
            //       response.data.prop[idx].value
            //     );
            // }
          }
        })
        .catch((error) => {
          throw "ERROR:CastsRepository.get (" + error + ")";
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    return {
      props,
      refAppBar,
      setting,
      ...toRefs(state),
      onBack,
      onHistory,
    };
  },
});
</script>
